/** 手机底部三岛：全局常量。说明见 docs/internal/frontend/mobile-island-dock.md */

export const MOBILE_ISLAND_HOME_PATH = '/dashboard';

export const MOBILE_ISLAND_BODY_CLASS = 'app-mobile-island-active';
export const MOBILE_ISLAND_SEARCH_OPEN_CLASS = 'app-mobile-island-search-open';
export const MOBILE_ISLAND_SEARCH_FOCUSED_CLASS = 'app-mobile-island-search-focused';
export const MOBILE_ISLAND_CONTEXTUAL_CLASS = 'app-mobile-island-contextual';

export const MOBILE_ISLAND_QUICK_LINKS_DIRECT_MAX = 4;

/**
 * 暂不接入底部三岛：pathname 精确匹配。
 * 已接入上下文岛：见 docs/internal/frontend/mobile-island-dock.md「保留默认/上下文岛」。
 */
export const MOBILE_ISLAND_EXCLUDED_EXACT_PATHS = [
	'/approval/list',
	'/notificationlist',
	'/statistics',
	'/profile',
	'/dashboard/total-debt-detail',
	'/manager/userlist',
	'/user/orderlist',
];

/**
 * 暂不接入：pathname 以此前缀开头即排除（注意勿覆盖已接入的工作台列表路径）。
 */
export const MOBILE_ISLAND_EXCLUDED_PREFIXES = [
	'/admin/',
	'/order/',
	'/approval/customer/detail/',
	'/approval/order/',
	'/approval/final-cost/',
	'/approval/quota/detail/',
];

/** @deprecated 使用 MOBILE_ISLAND_EXCLUDED_EXACT_PATHS */
export const MOBILE_ISLAND_EXCLUDED_PATHS = MOBILE_ISLAND_EXCLUDED_EXACT_PATHS;

export const isMobileIslandDockPathEnabled = (pathname) => {
	if (MOBILE_ISLAND_EXCLUDED_EXACT_PATHS.includes(pathname)) {
		return false;
	}
	return !MOBILE_ISLAND_EXCLUDED_PREFIXES.some((prefix) => pathname.startsWith(prefix));
};

/** 键盘 inset 超过此值才视为键盘已弹起（用于抬岛/留白，避免仅聚焦时光标被布局动画拉扯） */
export const MOBILE_ISLAND_KEYBOARD_OPEN_INSET_PX = 48;

/** 搜索输入已聚焦且键盘可能顶起列表时，短暂忽略滚动收起（毫秒） */
export const MOBILE_ISLAND_SEARCH_FOCUS_SCROLL_GRACE_MS = 500;

/** 从工作台回首页后，快速入口高亮持续时间 */
export const MOBILE_ISLAND_QUICK_LINK_HIGHLIGHT_MS = 2000;
